import { useAppSelector } from "@store/store";
import { selectSelectedEntity } from "@store/map/mapReducer";
import { useMap } from "@vis.gl/react-google-maps";
import { useContext, useEffect } from "react";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { MapContext } from "../MapContext";

/**
 * Move the map to center on an entity when selected.
 */
const EntityInteraction = () => {
  const selectedEntity = useAppSelector(selectSelectedEntity);
  const map = useMap();
  const { isMobile } = useWindowSize();
  const { setSelectedMarker } = useContext(MapContext);

  useEffect(() => {
    if (
      selectedEntity?.entity?.location?.latitude &&
      selectedEntity?.entity?.location?.longitude &&
      map
    ) {
      map.panTo({
        lat: selectedEntity?.entity?.location?.latitude,
        lng: selectedEntity?.entity?.location?.longitude,
      });
    }
  }, [map, selectedEntity]);

  useEffect(() => {
    if (!selectedEntity && !isMobile) {
      setSelectedMarker(null);
    }
  }, [selectedEntity, map, setSelectedMarker, isMobile]);

  return <></>;
};

export { EntityInteraction };
